import React from 'react';
import Modal from 'react-bootstrap/Modal';
import { FaUserCircle } from 'react-icons/fa';

const MobileQuestionModal = ({
  show,
  fullscreen,
  email,
  questions,
  currentQuestionIndex,
  getQuestionStatus,
  onSelect,
  onClose,
}) => (
  <Modal
    show={show}
    fullscreen={fullscreen}
    onHide={onClose}
    centered
    dialogClassName="solution-mobile-modal"
  >
    <Modal.Header closeButton>
      <Modal.Title>Question Navigator</Modal.Title>
    </Modal.Header>

    <Modal.Body className="mobile-palette-body">
      <div className="mobile-user">
        <FaUserCircle />
        <span>{email}</span>
      </div>

      <div className="solution-palette-grid solution-mobile-grid">
        {Array.isArray(questions) &&
          questions.map((item, index) => {
            const status = getQuestionStatus(item.q_id);

            return (
              <button
                type="button"
                key={item.q_id}
                className={`solution-palette-number ${status} ${
                  index === currentQuestionIndex ? 'active' : ''
                }`}
                onClick={() => onSelect(index)}
              >
                {index + 1}
              </button>
            );
          })}
      </div>
    </Modal.Body>
  </Modal>
);

export default MobileQuestionModal;
